import React, { useState, useEffect, lazy, Suspense } from 'react';
import {
    Form,
    Input,
    Button,
    Table,
    Row,
    Col,
    Space,
    message,
    Popconfirm,
} from 'antd';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
import {
    getApiWithAuthToken,
    deleteApiWithAuthToken,
    updateApiWithAuthToken,
} from '../../../api';
const LanguageAdd = lazy(() => import('./LanguageAdd'));
const Language = () => {
    const [form] = Form.useForm();
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [languageList, setLanguageList] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = inputType === 'text' ? <Input /> : <Input />;

        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                        rules={[
                            {
                                required: true,
                                message: `Please Input ${title}!`,
                            },
                        ]}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const isEditing = (record) => record.id === editingKey;

    const handleEditClick = (record) => {
        console.log(record);
        getApiWithAuthToken(`/api/v1/admin/languages/${record.id}`).then(
            (res) => {
                if (res.data) {
                    console.log(res.data);
                    form.setFieldsValue({
                        id: res.data[0].id,
                        name: res.data[0].name,
                    });
                    setEditingKey(record.id);
                }
            }
        );
    };

    const cancel = () => {
        setEditingKey('');
    };
    const handleSaveClick = async (key) => {
        const row = await form.validateFields();
        console.log(row);
        const id = key;
        updateApiWithAuthToken(`/api/v1/admin/languages/${id}`, row).then(
            (res) => {
                console.log(res);
                if (!res.error) {
                    setTimeout(() => {
                        message.success(res.msg);
                    }, 500);
                    setEditingKey('');
                    getLanguageList();
                } else {
                    setTimeout(() => {
                        message.error(res.errors);
                    }, 500);
                }
            }
        );
    };
    useEffect(() => {
        getLanguageList();
    }, []);
    // To Get all Table Data
    function getLanguageList() {
        getApiWithAuthToken('/api/v1/admin/languages').then((res) => {
            console.log(res);
            if (!res.error && res.data.length > 0) {
                setLanguageList([]);
                res.data.map((each) =>
                    setLanguageList((languageList) => [
                        ...languageList,
                        {
                            id: each.id,
                            key: each.id,
                            name: each.name,
                        },
                    ])
                );
            } else {
                if (res.errors) {
                    Object.values(res.errors).map((each) =>
                        message.error(each.msg)
                    );
                    setLanguageList([]);
                } else {
                    if (res.errors) {
                        message.error(res.errors);
                        setLanguageList([]);
                    } else {
                        message.error({ content: 'Network Error!' });
                        setLanguageList([]);
                    }
                }
            }
        });
    }
    //Delete
    function handleDeleteClick(id) {
        deleteApiWithAuthToken(`/api/v1/admin/languages/${id}`).then((res) => {
            console.log(res);
            let key = 'deleteClick';
            message.loading({ content: 'Loading...', key });
            if (res.error) {
                setTimeout(() => {
                    if (res.errors.errno === 1451) {
                        message.error({
                            content:
                                'Could not delete!, The language is being referred in another place',
                            duration: 2,
                        });
                    } else {
                        message.error({
                            content: res.errors.sqlMessage,
                            duration: 2,
                        });
                    }
                }, 1000);
            } else {
                setTimeout(() => {
                    message.success({ content: res.msg, key, duration: 2 });
                }, 1000);
                getLanguageList();
            }
        });
    }

    /* Table Functions started */
    const [searchText, setSearchText] = useState([]);
    const [searchedColumn, setSearchedColumn] = useState('');
    function getColumnSearchProps(dataIndex) {
        return {
            filterDropdown: ({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters,
            }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        // ref={node => {
                        //   this.searchInput = node;
                        // }}
                        placeholder={`Search ${dataIndex}`}
                        value={selectedKeys[0]}
                        onChange={(e) =>
                            setSelectedKeys(
                                e.target.value ? [e.target.value] : []
                            )
                        }
                        onPressEnter={() =>
                            handleSearch(selectedKeys, confirm, dataIndex)
                        }
                        style={{
                            width: 188,
                            marginBottom: 8,
                            display: 'block',
                        }}
                    />
                    <Space>
                        <Button
                            type='primary'
                            onClick={() =>
                                handleSearch(selectedKeys, confirm, dataIndex)
                            }
                            icon={<SearchOutlined />}
                            size='small'
                            style={{ width: 90 }}
                        >
                            Search
                        </Button>
                        <Button
                            onClick={() => handleReset(clearFilters)}
                            size='small'
                            style={{ width: 90 }}
                        >
                            Reset
                        </Button>
                    </Space>
                </div>
            ),
            filterIcon: (filtered) => (
                <SearchOutlined
                    style={{ color: filtered ? '#1890ff' : undefined }}
                />
            ),
            onFilter: (value, record) =>
                record[dataIndex]
                    .toString()
                    .toLowerCase()
                    .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: (visible) => {
                if (visible) {
                    // setTimeout(() => this.searchInput.select());
                }
            },
            render: (text) =>
                searchedColumn === dataIndex ? (
                    <Highlighter
                        highlightStyle={{
                            backgroundColor: '#ffc069',
                            padding: 0,
                        }}
                        searchWords={[searchText]}
                        autoEscape
                        textToHighlight={text.toString()}
                    />
                ) : (
                    text
                ),
        };
    }

    function handleSearch(selectedKeys, confirm, dataIndex) {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    function handleReset(clearFilters) {
        clearFilters();
        setSearchText('');
    }

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            editable: true,
            className: 'table-col-capitalize',
            ...getColumnSearchProps('name'),
        },
        {
            title: 'Edit',
            key: 'edit',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <a
                            href='javascript:;'
                            onClick={() => handleSaveClick(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </a>
                        <Popconfirm title='Sure to cancel?' onConfirm={cancel}>
                            <a>Cancel</a>
                        </Popconfirm>
                    </span>
                ) : (
                    <Button
                        size='small'
                        disabled={editingKey !== ''}
                        onClick={() => handleEditClick(record)}
                    >
                        Edit
                    </Button>
                );
            },
        },
        {
            title: 'Delete',
            key: 'delete',
            render: (_, record) => (
                <Popconfirm
                    title='Are you sure to delete this language?'
                    onConfirm={() => handleDeleteClick(record.id)}
                >
                    <Button danger size='small'>
                        Delete
                    </Button>
                </Popconfirm>
            ),
        },
    ];
    /* Table Functions end */
    // open drawer with reset data
    const showDrawerVisible = () => {
        showDrawer();
        form.resetFields();
    };
    //Drawer Open function
    const showDrawer = () => {
        setIsDrawerVisible(true);
    };

    //  Drawer Close function
    const handleCancel = () => {
        setIsDrawerVisible(false);
    };
    /*editable column seting function started*/
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    /*editable column seting function end*/
    return (
        <div>
            <Suspense fallback={<h1>Still Loading…</h1>}>
                <LanguageAdd
                    getLanguageList={getLanguageList}
                    setIsDrawerVisible={setIsDrawerVisible}
                    isDrawerVisible={isDrawerVisible}
                    handleCancel={handleCancel}
                />
            </Suspense>
            <Form form={form} component={false}>
                <Row style={{ margin: '2%' }}>
                    <Col span={24}>
                        <Table
                            title={() => (
                                <Row justify='space-between'>
                                    <h1 style={{ fontWeight: 'bold' }}>
                                        LANGUAGE
                                    </h1>
                                    <Button
                                        type='primary'
                                        onClick={showDrawerVisible}
                                    >
                                        ADD
                                    </Button>
                                </Row>
                            )}
                            bordered
                            components={{
                                body: {
                                    cell: EditableCell,
                                },
                            }}
                            columns={mergedColumns}
                            dataSource={languageList}
                            scroll={{ x: 200 }}
                            size='small'
                            rowClassName='editable-row'
                        />
                    </Col>
                </Row>
            </Form>
        </div>
    );
};
export default Language;
